import React from 'react';
import styled from 'styled-components';
import { theme } from '../theme';
import TypewriterText from './TypewriterText';

const HeroContainer = styled.section`
  min-height: 100vh;
  display: flex;
  align-items: center;
  background: ${theme.colors.surface};
  position: relative;
  padding-top: 120px;
`;

const HeroContent = styled.div`
  max-width: 1000px;
  margin: 0 auto;
  padding: 0 ${theme.spacing.xl};
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: ${theme.spacing.xxl};
  
  @media (max-width: ${theme.breakpoints.mobile}) {
    padding: 0 ${theme.spacing.lg};
    gap: ${theme.spacing.xl};
  }
`;

const TextContent = styled.div`
  z-index: 2;
`;

const Badge = styled.div`
  display: inline-flex;
  align-items: center;
  background: ${theme.colors.surface};
  border: 1px solid ${theme.colors.border.light};
  color: ${theme.colors.text.primary};
  padding: ${theme.spacing.sm} ${theme.spacing.md};
  border-radius: ${theme.borderRadius.xlarge};
  font-size: ${theme.typography.fontSize.sm};
  font-weight: ${theme.typography.fontWeight.medium};
  font-family: ${theme.typography.fontFamily.primary};
  gap: ${theme.spacing.xs};
  
  img {
    width: 20px;
    height: 20px;
    object-fit: contain;
  }
`;

const Title = styled.h1`
  font-size: ${theme.typography.fontSize.xxxxl};
  font-weight: ${theme.typography.fontWeight.bold};
  line-height: ${theme.typography.lineHeight.tight};
  color: ${theme.colors.text.primary};
  font-family: ${theme.typography.fontFamily.secondary};
  max-width: 800px;

  @media (max-width: ${theme.breakpoints.mobile}) {
    font-size: ${theme.typography.fontSize.xxxl};
  }
`;

const Subtitle = styled.h2`
  font-size: ${theme.typography.fontSize.xl};
  color: ${theme.colors.text.secondary};
  font-weight: ${theme.typography.fontWeight.normal};
  line-height: ${theme.typography.lineHeight.relaxed};
  max-width: 600px;
  font-family: ${theme.typography.fontFamily.primary};
  
  @media (max-width: ${theme.breakpoints.mobile}) {
    font-size: ${theme.typography.fontSize.lg};
  }
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: ${theme.spacing.md};
  flex-wrap: wrap;
  justify-content: center;
`;

const PrimaryButton = styled.button`
  background: ${theme.colors.primary};
  color: white;
  border: none;
  padding: ${theme.spacing.md} ${theme.spacing.xl};
  border-radius: ${theme.borderRadius.medium};
  font-size: ${theme.typography.fontSize.md};
  font-weight: ${theme.typography.fontWeight.medium};
  font-family: ${theme.typography.fontFamily.primary};
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: ${theme.colors.secondary};
    transform: translateY(-1px);
  }
`;



const Hero: React.FC = () => {
  return (
    <HeroContainer id="home">
      <HeroContent>
        <TextContent>
          <Badge>🎉 厨记智能菜谱推荐</Badge>
          <Title>
          厨记
            <br/>
            <TypewriterText 
              text="会选菜 就会做菜" 
              speed={120} 
              delay={800}
            />
          </Title>
          <Subtitle>
            智能菜谱推荐系统，根据您的食材和偏好，生成个性化菜谱
            <br/>
          让烹饪变得简单而有趣
          </Subtitle>
          <br/>

          <ButtonGroup>
            <PrimaryButton onClick={() => window.location.href = 'mailto:chuji_fun@163.com?subject=联系我们&body=您好，我想了解更多关于厨记的信息。'}>
              开始体验
            </PrimaryButton>
          </ButtonGroup>
        </TextContent>
      </HeroContent>
    </HeroContainer>
  );
};

export default Hero;
